

































import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import Vue from "vue";
import { state } from "./data/state";
export default Vue.extend({
  components: { DropDownSimple },
  setup() {
    const {
      data_sources,
      set_selected_source,
      selected_source,
      info_types,
      selected_info_type,
      set_selected_info_type,
      playbooks,
      selected_playbook,
      set_selected_playbook,
    } = state;
    return {
      data_sources,
      set_selected_source,
      selected_source,
      info_types,
      selected_info_type,
      set_selected_info_type,
      playbooks,
      selected_playbook,
      set_selected_playbook,
    };
  },
});
